(function(){
  function rnd(a,b){return a+Math.random()*(b-a)}
  function furTile(size,base,light,dark,count){
    var c=document.createElement('canvas');c.width=c.height=size;var g=c.getContext('2d');
    g.fillStyle=base;g.fillRect(0,0,size,size);g.lineCap='round';
    for(var i=0;i<count;i++){
      var x=rnd(-10,size+10),y=rnd(-10,size+10),len=rnd(10,30),ang=rnd(Math.PI*.35,Math.PI*.65)+rnd(-.35,.35);
      var cx=x+Math.cos(ang)*len*.5+rnd(-5,5),cy=y+Math.sin(ang)*len*.5,ex=x+Math.cos(ang)*len,ey=y+Math.sin(ang)*len,t=Math.random();
      g.strokeStyle=t<.45?light:(t<.8?dark:base);g.globalAlpha=rnd(.25,.75);g.lineWidth=rnd(.8,2.2);
      for(var ox=-size;ox<=size;ox+=size){for(var oy=-size;oy<=size;oy+=size){g.beginPath();g.moveTo(x+ox,y+oy);g.quadraticCurveTo(cx+ox,cy+oy,ex+ox,ey+oy);g.stroke();}}
    }
    g.globalAlpha=1;return c.toDataURL('image/png');
  }
  function fringeTile(w,h,colors){
    var c=document.createElement('canvas');c.width=w;c.height=h;var g=c.getContext('2d');g.lineCap='round';
    for(var i=0;i<260;i++){var x=rnd(0,w),len=rnd(h*.35,h*.98),bend=rnd(-6,6);
      g.strokeStyle=colors[(Math.random()*colors.length)|0];g.globalAlpha=rnd(.55,1);g.lineWidth=rnd(1,2.6);
      for(var ox=-w;ox<=w;ox+=w){g.beginPath();g.moveTo(x+ox,0);g.quadraticCurveTo(x+ox+bend,len*.6,x+ox+bend*1.6,len);g.stroke();}}
    return c.toDataURL('image/png');
  }
  try{
    var r=document.documentElement.style;
    r.setProperty('--fz-fur-tex','url('+furTile(180,'#9FAE3F','#C4D067','#6E7A24',1400)+')');
    r.setProperty('--fz-fur-tex-dark','url('+furTile(180,'#1E3A2B','#2F5642','#142A1F',1200)+')');
    r.setProperty('--fz-fur-tex-white','url('+furTile(160,'#F3EFE3','#FFFFFF','#D9D2BE',1300)+')');
    r.setProperty('--fz-fur-tex-page','url('+furTile(220,'#A7B64A','#C9D66E','#7C8A2C',1700)+')');
    r.setProperty('--fz-fringe-white','url('+fringeTile(120,26,['#FFFFFF','#F3EFE3','#E4DDCB'])+')');
    r.setProperty('--fz-fur-tex-green','url('+furTile(180,'#6F8228','#93A83E','#4E5E17',1500)+')');
    r.setProperty('--fz-fringe','url('+fringeTile(120,26,['#9FAE3F','#C4D067','#6E7A24'])+')');
    r.setProperty('--fz-fringe-dark','url('+fringeTile(120,26,['#1E3A2B','#2F5642','#142A1F'])+')');
  }catch(e){}
  function tick(){
    var els=document.querySelectorAll('[data-fz-countdown]');if(!els.length)return;
    var now=new Date(),end=new Date(now);end.setHours(24,0,0,0);
    var s=Math.max(0,Math.floor((end-now)/1000)),txt=[Math.floor(s/3600),Math.floor(s%3600/60),s%60].map(function(n){return String(n).padStart(2,'0')}).join(':');
    els.forEach(function(el){el.textContent=txt});
  }
  function initBundles(){
    document.querySelectorAll('[data-fz-bundle]').forEach(function(root){
      var form=root.querySelector('form'),msg=root.querySelector('.fz-msg');if(!form||form.dataset.ready)return;form.dataset.ready='1';
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var id=form.querySelector('[name=id]').value,qty=parseInt((form.querySelector('[name=fz_qty]:checked')||{}).value||'1',10);
        msg.textContent='Adding…';
        fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty}]})})
          .then(function(r){if(!r.ok)throw 0;return r.json()})
          .then(function(){msg.textContent='Added to cart. Taking you to checkout…';window.location.href=(window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart';})
          .catch(function(){msg.textContent='Could not add to cart. Please try again.'});
      });
    });
  }
  function init(){tick();initBundles();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  setInterval(tick,1000);
  document.addEventListener('shopify:section:load',init);
})();
